import * as Yup from "yup";
import { telephoneIsValid } from "../../util/validation";

export const SignUpSchema = Yup.object().shape({
  nome: Yup.string().required("Nome não pode ser vazio"),
  email: Yup.string()
    .email("Informe um e-mail válido")
    .required("E-mail não pode ser vazio"),
  celular: Yup.string().required("Telefone não pode ser vazio").test(
    "celular",
    "Digite um número de celular válido",
    (celular = "") => {
      return telephoneIsValid(celular);
    }
  ),
  data_nascimento: Yup.string().required(
    "Data de nascimento não pode ser vazio"
  ),
  genero: Yup.string().required("Sexo não pode ser vazio")
});